;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Icon } from '@qogita/ui/v2/icon'
import { Navigation, NavigationItem } from '@qogita/ui/v2/navigation'
import { Separator } from '@qogita/ui/v2/separator'
import Link from 'next/link'
import React from 'react'
import { GREETINGS } from 'src/core/constants/copy'
import { routes } from 'src/deprecated/utils/routes'

interface SidebarMyProfileButtonProps {
  companyName?: string
  onClickRoute?: () => void
  isActive: boolean
}

export function SidebarMyProfileButton({
  companyName,
  onClickRoute,
  isActive,
}: SidebarMyProfileButtonProps) {
  const isLoggedIn = !!companyName

  return (
    <>
      <Separator orientation="horizontal" />
      <Navigation>
        <NavigationItem
          as={Link}
          isActive={isActive}
          onClick={onClickRoute}
          href={routes.myProfile()}
          // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
          className="text-gray-900 group-hover:bg-gray-50 hover:bg-gray-50 focus-visible:bg-gray-50"
        >
          <div className="flex gap-3">
            <Icon
              name="heroicons/solid/user-circle"
              // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
              className="size-8 text-gray-400"
            />
            <div className="flex flex-col gap-0.5 overflow-hidden text-xs">
              <p>
                {GREETINGS.hello}, {companyName}
              </p>
              <p className="font-semibold">Account</p>
            </div>
          </div>
        </NavigationItem>
      </Navigation>
      {isLoggedIn ? <Separator orientation="horizontal" /> : null}
    </>
  )
}
